<template>
  <div class="c-content">
    <div class="c1"  v-if="!tenmessages">
      <div class="c1d1">
        领奖ID：
        <Input v-model="value" placeholder clearable style="width: 200px" />
      </div>
      <div class="c1d2">
        <Button type="primary" @click="determine">确定</Button>
      </div>
    </div>
    <div class="c1" v-if="tenmessages">
      <div class="c1d1">
        通知：{{tenmessage}}
      </div>
      <div class="c1d2">
        <Button type="primary" @click="determines">关闭</Button>
      </div>
    </div>
    <div class="c2" v-if="c2true">
      <Icon class="closec2" @click="closec2" type="ios-close-circle" />
      <div class="c1d1 c1d11">领奖ID：{{FormData.prizeId}}</div>
      <div class="c1d1 c1d12">微信名称：{{FormData.nickname}}</div>
      <div class="c1d1 c1d13">奖品名称：{{FormData.prize}}</div>
      <div class="c1d1 c1d14">获奖时间：{{FormData.winTime}}</div>
      <div class="c1d1 c1d15" v-if="FormData.isReceive === 1">
        奖品状态：
        <Button type="primary" disabled>已领取</Button>
      </div>
      <div class="c1d1 c1d16" v-if="FormData.isReceive === 1">领取时间：{{FormData.receiveTime}}</div>
      <div class="c1d1 c1d18" v-if="FormData.isReceive === 1">领取店铺：{{FormData.receiveStore}}</div>
      <div class="c1d2 c1d17" v-if="FormData.isReceive !== 1">
        <Button type="primary" @click="Confirmclaim">确认领取</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      xgth5token: "",
      xgth5user: "",
      c2true: false,
      FormData: {
        isReceive: "",
        nickname: "",
        prize: "",
        prizeId: "",
        receiveStore: "",
        receiveTime: "",
        uid: "",
        winTime: ""
      },
      tenmessages: false,
      tenmessage:''
    };
  },
  methods: {
    determines() {
      this.tenmessages = false
      this.value = ''
    },
    determine() {
      this.$axios
        .post(
          "/h5/admin/getPrizeUserInfo",
          {
            prizeId: this.value
          },
          {
            headers: {
              Authorization: this.xgth5token
            }
          }
        )
        .then(res => {
          if (res.data.code === 0) {
            this.value = "";
            this.c2true = true;
            let lists = res.data.data;
            this.FormData.isReceive = lists.isReceive;
            this.FormData.nickname = lists.nickname;
            this.FormData.prize = lists.prize;
            this.FormData.prizeId = lists.prizeId;
            this.FormData.receiveStore = lists.receiveStore;
            this.FormData.receiveTime = lists.receiveTime;
            this.FormData.uid = lists.uid;
            this.FormData.winTime = lists.winTime;
          }else if (res.data.code === -2) {
            this.tenmessages = true
            this.tenmessage = res.data.message
          }  else {
            this.$Message.error("未获取到中奖信息");
          }
        });
    },
    closec2() {
      this.c2true = false;
    },
    Confirmclaim() {
      this.$axios
        .post(
          "/h5/admin/receivePrize",
          {
            uid: this.FormData.uid,
            storeName: this.xgth5user
          },
          {
            headers: {
              Authorization: this.xgth5token
            }
          }
        )
        .then(res => {
          if (res.data.code === 0) {
            this.c2true = false;
            this.$Message.success("已领取");
          } else {
            this.$Message.error("领奖失败");
          }
        });
    }
  },
  created() {
    this.xgth5token = localStorage.getItem("xgth5token");
    this.xgth5user = localStorage.getItem("xgth5user");
    if (this.xgth5token !== null) {
      // console.log(this.xgth5token);
    } else {
      this.$router.push({
        path: "/H5BackLogin"
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.c-content {
  position: relative;
  height: 500px;
}
.c1,
.c2 {
  width: 500px;
  height: 300px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  position: absolute;
  top: calc(50% - 150px);
  left: calc(50% - 250px);
  border-radius: 10px;
}
.c2 {
  height: 330px;
  background: white;
}
.c1d1 {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 100px;
}
.c1d2 {
  width: 100%;
  text-align: center;
  position: absolute;
  top: 200px;
}
.c1d11 {
  top: 50px;
}
.c1d12 {
  top: 90px;
}
.c1d13 {
  top: 130px;
}
.c1d14 {
  top: 170px;
}
.c1d15 {
  top: 210px;
}
.c1d16 {
  top: 260px;
}
.c1d18 {
  top: 290px;
}
.c1d17 {
  top: 250px;
}
.closec2 {
  font-size: 30px;
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
</style>
